import React, { Component } from 'react'
import { Tabs, Card, Spin } from 'antd'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import Main from './../../../components/main'
import { API_GET_USERS } from '../../../api'
import ProfileDetail from './../profile-detail'
import Documents from './../documents'
import Devices from './../devices'
import Events from './../events'

class UserDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userId: this.props.match.params.userId,
      dataUser: {},
    }
  }

  componentDidMount() {
    this.getUserById(this.state.userId)
  }

  getUserById(userId) {
    API_GET_USERS(userId).then((res) => {
      this.setState({ dataUser: res.data })
    })
      .catch((err) => {
        throw err
      })
  }


  callback = key => key

  render() {
    const { userId, dataUser } = this.state

    return (
      <Main>
        {
          dataUser ?
            <div>
              <h2>[{userId}] {dataUser.fullName}</h2>
              <hr />
              <Tabs onChange={this.callback} type="card">
                <Tabs.TabPane tab="Profile Detail" key="1"><ProfileDetail userId={userId} dataUser={dataUser} /></Tabs.TabPane>
                <Tabs.TabPane tab="Documents" key="2"><Documents userId={userId} dataUser={dataUser} /></Tabs.TabPane>
                <Tabs.TabPane tab="Devices" key="3"><Devices dataUser={dataUser} userId={userId} /></Tabs.TabPane>
                <Tabs.TabPane tab="Events" key="4"><Events dataUser={dataUser} userId={userId} /></Tabs.TabPane>
              </Tabs>
            </div>
          : <div><Card style={{ textAlign: 'center' }}><Spin /></Card></div>
        }
      </Main>
    )
  }
}

UserDetail.defaultProps = {
  userId: '',
  match: null,
}

UserDetail.propTypes = {
  userId: PropTypes.string,
  match: PropTypes.object,
}

export default withRouter(UserDetail)



// WEBPACK FOOTER //
// src/pages/user/user-detail/index.js